import { Badge } from '@fluentui/react-components';
import type { FC } from 'react';
import type { ReferralStatus } from '@/config/services';
import { STATUS_LABELS } from '@/config/services';

interface StatusBadgeProps {
  status: ReferralStatus;
}

type BadgeAppearance = 'filled' | 'ghost' | 'outline' | 'tint';
type BadgeColor =
  | 'brand'
  | 'danger'
  | 'important'
  | 'informative'
  | 'severe'
  | 'subtle'
  | 'success'
  | 'warning';

interface BadgeConfig {
  color: BadgeColor;
  appearance: BadgeAppearance;
}

const STATUS_BADGE_CONFIG: Record<ReferralStatus, BadgeConfig> = {
  Submitted: { color: 'informative', appearance: 'tint' },
  UnderReview: { color: 'warning', appearance: 'tint' },
  Qualified: { color: 'success', appearance: 'tint' },
  InProgress: { color: 'brand', appearance: 'tint' },
  Won: { color: 'success', appearance: 'filled' },
  Lost: { color: 'danger', appearance: 'tint' },
  Disqualified: { color: 'subtle', appearance: 'tint' },
};

const FALLBACK_CONFIG: BadgeConfig = { color: 'subtle', appearance: 'tint' };

export const StatusBadge: FC<StatusBadgeProps> = ({ status }) => {
  const config = STATUS_BADGE_CONFIG[status] ?? FALLBACK_CONFIG;

  return (
    <Badge color={config.color} appearance={config.appearance} shape="rounded">
      {STATUS_LABELS[status] ?? status}
    </Badge>
  );
};
